import React from 'react';
import { Plus, Sparkles } from 'lucide-react';
import { Card } from './Card';
import ActionButton from './ActionButton';

/**
 * Additional experiences purchased for this participant, with Remove per item, Add, and the audit
 * list. CamperDetail only renders it when the program offers additional experiences, as before.
 * `renderHtml` is helper's getHtml: titles are stored as rich text.
 */
const AdditionalExperienceCard = ({ experiences = [], auditCount = 0, onShowAudits, onAdd, onRemove, renderHtml }) => (
    <Card
        id="experience"
        title="Additional Experience"
        icon={Sparkles}
        actions={
            <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2">
                {auditCount > 0
                    ? <button type="button" onClick={onShowAudits} className="tw-text-sm tw-text-brand-600 hover:tw-text-brand-700 hover:tw-underline">Audits ({auditCount})</button>
                    : null}
                <ActionButton variant="primary" icon={Plus} onClick={onAdd}>Add Experience</ActionButton>
            </div>
        }
    >
        {experiences.length
            ? <ul className="tw-flex tw-flex-col">
                {experiences.map((exp, i) => (
                    <li key={exp._id || i} className="tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-3 tw-border-t tw-border-neutral-100 tw-py-3 first:tw-border-t-0 first:tw-pt-0 last:tw-pb-0">
                        <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
                            <div className="tw-break-words tw-text-sm tw-font-medium tw-text-neutral-800">{renderHtml(exp.title)}</div>
                            <div className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1 tw-text-sm tw-text-neutral-600">
                                <span>Number purchased: <span className="tw-text-neutral-800">{exp.numberOfBooking}</span></span>
                                <span>Price: <span className="tw-text-neutral-800">${Number(exp.price || 0).toFixed(2)}</span></span>
                            </div>
                            {exp?.answer
                                ? <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-text-sm tw-text-neutral-600">
                                    Answer:
                                    <span className="tw-rounded tw-bg-neutral-100 tw-px-2 tw-py-0.5 tw-text-neutral-700">{exp.answer?.answer}</span>
                                </div>
                                : null}
                        </div>
                        <ActionButton variant="primary" onClick={() => onRemove(exp)}>Remove</ActionButton>
                    </li>
                ))}
            </ul>
            : <p className="tw-text-sm tw-italic tw-text-neutral-400">No additional experiences added yet.</p>}
    </Card>
);

export default AdditionalExperienceCard;
